
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { CreditCard, Wallet } from "lucide-react";

interface PaymentMethodSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (method: string) => void;
}

const PaymentMethodSelector = ({ isOpen, onClose, onSelect }: PaymentMethodSelectorProps) => {
  const paymentMethods = [
    { id: 'credit-card', name: 'Credit Card', icon: CreditCard },
    { id: 'paypal', name: 'PayPal', icon: Wallet },
    { id: 'mobile-money', name: 'Mobile Money', icon: Wallet },
    { id: 'orange-money', name: 'Orange Money', icon: Wallet },
    { id: 'mpesa', name: 'M-Pesa', icon: Wallet },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center mb-4">
            Select Payment Method
          </DialogTitle>
        </DialogHeader>
        <RadioGroup className="gap-4" defaultValue="credit-card">
          {paymentMethods.map((method) => (
            <div
              key={method.id}
              className="flex items-center space-x-4 border rounded-lg p-4 cursor-pointer hover:border-purple-500 transition-colors"
              onClick={() => onSelect(method.id)}
            >
              <RadioGroupItem value={method.id} id={method.id} />
              <method.icon className="h-5 w-5 text-purple-600" />
              <label
                htmlFor={method.id}
                className="flex-1 text-lg font-medium cursor-pointer"
              >
                {method.name}
              </label>
            </div>
          ))}
        </RadioGroup>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodSelector;
